import React, { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
// import CheckIn from './Pages/CheckIn';
// import Deferment from './Pages/DefermentMessage';
// import Review from './Pages/Review';
import MobileLogin from './Pages/MobileLogin';

const idleTimeoutMilliseconds = 1000 * 60 * 3;

export default function App() {
    useEffect(() => {
        ReactGA.initialize('UA-17147565-26');
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    const doNothing = () => {};

    // eslint-disable-next-line no-unused-vars
    const handleOnIdle = (event) => {
        const kioskMode = !!window.location.search.match(/kiosk/);
        if (kioskMode) {
            window.location.replace('/?kiosk=1&idle=1');
        }
    };

    // eslint-disable-next-line no-unused-vars
    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        timeout: idleTimeoutMilliseconds,
        onIdle: handleOnIdle,
        onActive: doNothing,
        onAction: doNothing,
        debounce: 500
    });

    return (
        <div>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={MobileLogin} />
                    {/* This is a SPA with prop drilling; we do not need these routes except for development */}
                    {/* <Route exact path="/checkin" component={CheckIn} />
                    <Route exact path="/deferment" component={Deferment} />
                    <Route exact path="/review" component={Review} /> */}
                </Switch>
            </BrowserRouter>
        </div>
    );
}
